<scaffold-dialog [title]="'select_service_to_access'|translation" size="fit" [ngClass]="{'hidden': !visible}">
  <div scaffoldDialogBody>
    <app-scaffold-type [(selected)]="selectedValue" (optionsAvailable)="show($event)"></app-scaffold-type>
    </div>
    <div scaffoldDialogButtons>
      <button pButton severity="primary" (click)="close()">{{'select'|translation}}</button>
    </div>
</scaffold-dialog>
